import React from 'react'

export default function InformacionAcademica() {
  return (
    <div>
      InformacionAcademica
    </div>
  )
}
